import React from "react";
import styled from "styled-components";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import NextImage from "next/image";
import { LabelH3 } from "@motorata/base-ui.components.atoms.typography";
import List from "@motorata/base-ui.components.molecules.list";

const GiftModalContent = () => {
  return (
    <InfoBlock
      padding="S"
      background="primaryBackground"
      marginBottom="S"
      borderRadius="borderRadius"
    >
      <Box>
        <NextImage
          priority={true}
          height={85}
          width={85}
          src="/images/gift.png"
          alt="Prezent MotoUp"
        />
      </Box>
      <Box>
        <LabelH3 color="primary" display="block" marginBottom="XS">
          Dlaczego warto otrzymać bezpłatną ofertę?
        </LabelH3>
        <StyledList
          type="secondary"
          list={[
            "porównaj oferty konkurencji",
            "otrzymaj profesjonalną ekspertyzę",
            "skonsultuj prawne szczegóły finansowania",
          ]}
        />
      </Box>
    </InfoBlock>
  );
};

export default GiftModalContent;

const InfoBlock = styled(Box)`
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  display: flex;
  align-items: center;
  grid-gap: ${({ theme }) => theme.space.S};

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

const StyledList = styled(List)`
  > * {
    margin-bottom: ${({ theme }) => theme.space.XS};
  }
`
